// extracted by mini-css-extract-plugin
export default {"auth-popover":"VY3X4","burger-button":"hF3oX","burger-button-skeleton":"S8u11"};